package presentation.screens.customer.home

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.core.screen.ScreenKey
import cafe.adriel.voyager.core.screen.uniqueScreenKey
import cafe.adriel.voyager.navigator.LocalNavigator
import component.navigation.BrandedNavBar
import component.offers.OfferBannerList
import component.product.CategoriesList
import component.product.ProductList
import feature.auth.viewModel.AuthViewModel
import feature.customer.viewModel.CustomerViewModel
import feature.offerBanner.viewModel.OfferBannerViewModel
import feature.product.viewModel.ProductViewModel
import feature.productCategory.viewModel.ProductCategoryViewModel
import presentation.screens.customer.membership.MembershipRow
import presentation.screens.customer.product_category_details.ProductCategoryDetailsScree
import theme.ThemeColor

class DashboardScreen : Screen {


    override val key: ScreenKey
        get() = uniqueScreenKey

    @Composable
    override fun Content() {
        val productCategoryViewModel = ProductCategoryViewModel()
        val productViewModel = ProductViewModel()
        val offerBannerViewModel = OfferBannerViewModel()
        val authViewModel = AuthViewModel()
        val customerViewModel = CustomerViewModel()
        val navigator = LocalNavigator.current
        LaunchedEffect(key1 = Unit) {
            productViewModel.fetchAllProduct()
            authViewModel.checkIfLoggedIn()
        }
        Column(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
            BrandedNavBar(title = "Bharat Grocery Store")
            LazyColumn {
                item {
                    CategoriesList(
                        productCategoryViewModel,
                        onClick = {
                            val screen = ProductCategoryDetailsScree()
                            screen.viewModel = productCategoryViewModel
                            navigator?.push(screen)
                        }
                    )
                }
                item {
                    OfferBannerList(
                        offerBannerViewModel,
                        onClick = {

                        }
                    )
                }
                item {
                    Box(modifier = Modifier.padding(8.dp)) {
                        MembershipRow(authViewModel = authViewModel, customerViewModel)
                    }
                }
                item {
                    Spacer(modifier = Modifier.height(8.dp))
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(8.dp),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Text(
                            text = "Popular Product",
                            fontWeight = FontWeight.Bold,
                            fontSize = 16.sp
                        )
                        Text(text = "See More", color = ThemeColor.shared().TextColor)
                    }
                    Spacer(modifier = Modifier.height(8.dp))
                    ProductList(viewModel = productViewModel) {
//                    navigator?.push(ProductDetailScreen())
                    }
                    Spacer(modifier = Modifier.height(8.dp))
                }
            }
//
//            Column(
//                modifier = Modifier
//                    .fillMaxSize()
//                    .padding(start = 8.dp, end = 8.dp)
//            ) {
////                Spacer(modifier = Modifier.height(15.dp))
//
//
//                Spacer(modifier = Modifier.height(30.dp))
//
//                Spacer(modifier = Modifier.height(15.dp))
//                Spacer(modifier = Modifier.height(15.dp))
//
//            }
        }

    }
}